// extracted by mini-css-extract-plugin
export default {"onnVideoEmbed__heading":"OnnVideo_onnVideoEmbed__heading__Zhwnn","onnVideoEmbed__description":"OnnVideo_onnVideoEmbed__description__5h65o"};